import { fork } from 'redux-saga/effects'

import * as watchers from './signup-watchers'

export default [
  fork(watchers.watchSignupSubmit),
  fork(watchers.watchSignupSubmitSuccess),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/signup/index.js
 **/